function displayValidity(e) {
  if (e.target.validity.valid === true) {
    e.target.classList.remove('invalid');
    e.target.classList.add('valid');
  } else {
    e.target.classList.add('invalid');
    e.target.classList.remove('valid');
  }
}

export function onBlur(e) {
  e.target.classList.remove('pristine');
  e.target.classList.add('dirty');

  displayValidity(e);

  if (e.target.value.length) {
    e.target.reportValidity();
  }
}

export function onInputChange(e) {
  const prefix = e.target.form.name || 'edit';
  displayValidity(e);
  e.target.setCustomValidity('');
  sessionStorage.setItem(`${prefix}__${e.target.name}`, e.target.value);
}

export function onChange(e) {
  e.target.classList.remove('pristine');
  onInputChange(e);
}

export function onInvalid(e) {
  e.target.classList.remove('pristine');
  e.target.classList.remove('valid');
  e.target.classList.add('invalid');
  e.target.classList.add('dirty');
  e.target.setCustomValidity(e.target.dataset.invalid_message);
}

export function onCheckboxChange(e) {
  const prefix = e.target.form.name || 'edit';
  if (e.target.validity.valid) {
    e.target.classList.remove('invalid');
    e.target.classList.add('valid');
  }
  e.target.setCustomValidity('');
  sessionStorage.setItem(`${prefix}__${e.target.name}`, e.target.value);
}
